export enum StatusCode {
  Success = 200,
  Created = 201,
  Bad_Request = 400,
  Unauthorized = 401,
}
